import { render, staticRenderFns } from "./OwnVessel.vue?vue&type=template&id=309b0c74&"
import script from "./OwnVessel.vue?vue&type=script&lang=js&"
export * from "./OwnVessel.vue?vue&type=script&lang=js&"
import style0 from "./OwnVessel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports